const getPageContainerSelector = (rootState) => rootState.ws.template.meta.pageContainer;

export default getPageContainerSelector;
